module.exports = __webpack_public_path__ + "img/cover-img.d6957310.jpg";